import { css } from "@emotion/css";
import palette from "utility/ui/palette";

const styles = {
  container: css`
    width: 100%;
  `,
  icon: css`
    font-size: 16px !important;
    color: ${palette.grey400};
  `,
};

export default styles;
